module.exports = __webpack_public_path__ + "static/img/demo_page_34.bfd2560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_page_34.png
// module id = kHhz
// module chunks = 31